import { getCountries } from "../../../api/countries";
import { getEmployeeNotPaiedHours, getEmployees } from "../../../api/employees";

export const MEDIA_FIELDS = [
  { key: "date", label: "Date", type: "date" },
  /*{
    key: "priceComponents",
    label: "Price Components",
    type: "select",
    apiResKey: "priceComponents",
    api: getPriceComponents,
    apiMeta: {type: "employee"},
    isMulti: true,
  },*/
  {
    key: "employees",
    label: "Employee",
    type: "select",
    apiResKey: "employees",
    api: getEmployees,
    isMulti: true
  }
  
];

export const ADDITIONAL_FIELDS = [

];

const FIELDS = [...MEDIA_FIELDS, ...ADDITIONAL_FIELDS];

export function calcPrice(payslipe){

  let total = 0

  payslipe.hours.map(h => {
    total += h.day_hours*h.basePrice + h.night_hours*h.nightPrice
  })

  return total

}

export default FIELDS;
